import { render, staticRenderFns } from "./PopupNotification.vue?vue&type=template&id=b07a3d10&scoped=true"
import script from "./PopupNotification.vue?vue&type=script&lang=js"
export * from "./PopupNotification.vue?vue&type=script&lang=js"
import style0 from "./PopupNotification.vue?vue&type=style&index=0&id=b07a3d10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07a3d10",
  null
  
)

export default component.exports